import React from 'react';
import { ONLINE_THRESHOLD } from '@bilderit/offline-link';
import { useIsEffectivelyOnline } from '@/hooks/useIsEffectivelyOnline';

const countFormatter = new Intl.NumberFormat('es-AR');

type MachineSearchNoticeProps = {
  receivedCount: number;
  totalItems?: number | null;
  limit: number;
  loading: boolean;
  active: boolean;
};

export const MachineSearchNotice: React.FC<MachineSearchNoticeProps> = ({
  receivedCount,
  totalItems,
  limit,
  loading,
  active,
}) => {
  const online = useIsEffectivelyOnline(ONLINE_THRESHOLD);

  // Offline requests can remain queued while cached results are available.
  if (!active || (online && loading)) return null;

  const reachedLimit = receivedCount >= limit;
  const hasTotal = online && totalItems != null;
  const hasMore = hasTotal ? totalItems > receivedCount : reachedLimit;
  if (online && !hasMore) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="border-t px-3 py-2 text-center text-xs text-muted-foreground"
    >
      {!online && <p>Buscando entre los equipos disponibles sin conexión</p>}
      {hasTotal && hasMore ? (
        <p>
          {countFormatter.format(receivedCount)} de{' '}
          {countFormatter.format(totalItems)} equipos; refiná la búsqueda
        </p>
      ) : hasMore ? (
        <p>Mostrando hasta {limit} equipos; refiná la búsqueda</p>
      ) : null}
    </div>
  );
};
